// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2-TZr","header":"MergedInvoice_header__1ogzF"};